import { render, staticRenderFns } from "./registrationProtocol.vue?vue&type=template&id=1b66cfa0"
import script from "./registrationProtocol.vue?vue&type=script&lang=js"
export * from "./registrationProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports